import { FC } from 'react'
import React from 'react'
import numeral from 'numeral'

import { DataGridCell } from '@imodules/react-components/controls/DataGridCell'
import { toHslaString } from '@imodules/react-components/forms/shared'

export interface DonorRollDataGridRowProps {
    data: ApiDonorRollDataRecord
    donorRollSettings: DonorRollSettingsDto
    anonymousDonorVerbiage: string
    anonymousAmountVerbiage: string
    designationVerbiage: string
    includeDesignation: boolean | undefined
}

export interface AvatarCellProps {
    name?: string | null,
    avatarType: string // 'Image' 'FirstInitial' 'None'
    firstInitialBackgroundColor?: string
    firstInitialFontColor?: string
    userProfileImage?: string | null
    donorAvatarImage?: string | null
    anonymousDonorVerbiage: string
}
export const getAvatarCellImage: (anonymous: boolean, userProfileImage: string | undefined | null, donorAvatarImage: string) => string =
    (anonymous, userProfileImage, donorAvatarImage) =>
        /* userProfileImage && !anonymous ? `url(${userProfileImage})` : */`url(data:image;base64,${donorAvatarImage})`

export const shouldShowFirstInitial: (avatarType: string, userProfileImage: string | undefined | null, name: string) => boolean =
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    (avatarType, userProfileImage, name) =>
        avatarType === 'FirstInitial'/* && (!userProfileImage || name === 'Anonymous'))*/

export const shouldShowImage: (avatarType: string, userProfileImage: string | undefined | null, anonymousDonorVerbiage: string, name?: string | null) => boolean =
    (avatarType, userProfileImage, anonymousDonorVerbiage, name) =>
        ((avatarType === 'Image') || (avatarType === 'FirstInitial' && (Boolean(userProfileImage) && name !== anonymousDonorVerbiage)))

export const AvatarCell: FC<AvatarCellProps> = props => {
    const initial = props.name && props.name.length > 0 ? props.name.substr(0, 1).toUpperCase() : ''

    return (
        <DataGridCell className={'donor-item-icon'} widthType={{ kind: 'fixedWidth', fixedWidth: '60px' }} isColumnHeader={false} >

            {shouldShowFirstInitial(props.avatarType, props.userProfileImage, props.name || '')
                ? <div
                    className={'avatar'}
                >
                    <span
                        className="donor-roll-initial-font"
                    >
                        {initial}
                    </span>
                </div>
                : shouldShowImage(props.avatarType, props.userProfileImage, props.anonymousDonorVerbiage, props.name) &&
                <div
                    className={'avatar'}
                />
            }
        </DataGridCell>
    )
}

export const DonorRollDataGridRow: FC<DonorRollDataGridRowProps> = props => {
    const { Name, Donation, ProfileImage, DesignationName } = props.data
    const { donateVerbiage, donorAvatarType, donorAvatarFirstInitialBackgroundColor, donorAvatarFirstInitialFontColor, donorAvatarImage } = props.donorRollSettings.layoutSettings
    const newName = Name ? Name : props.anonymousDonorVerbiage
    const showDesignation = props.includeDesignation && DesignationName
    return (
        <div className="data-grid-row donor-roll-scoreboard">
            <ul>
                {donorAvatarType !== 'None' &&
                    <AvatarCell
                        avatarType={donorAvatarType}
                        name={newName}
                        firstInitialBackgroundColor={toHslaString(donorAvatarFirstInitialBackgroundColor)}
                        firstInitialFontColor={toHslaString(donorAvatarFirstInitialFontColor)}
                        donorAvatarImage={donorAvatarImage}
                        userProfileImage={ProfileImage}
                        anonymousDonorVerbiage={props.anonymousDonorVerbiage}
                    />
                }
                <DataGridCell
                    className={'scoreboard-donationMessage-column data-grid-column'}
                    widthType={{ kind: 'width', width: 1 }}
                    isColumnHeader={false}
                >
                    <div className="scoreboard-donor-roll-verbiage-container">
                        <span className="scoreboard-donor-roll-verbiage-name"> {newName}</span>
                        {
                            <span className={Donation ? 'scoreboard-donor-roll-verbiage-donation' : 'scoreboard-donor-roll-anonymous-verbiage-donation'}> {donateVerbiage}</span>}
                        {
                            Donation ?
                                <span className="scoreboard-donor-roll-verbiage-amount"> <span className="currency-symbol-span">{imod.cms.scoreboards.verbiage.globalCurrencySymbol}</span>{numeral(Donation).format('0,0.00')}</span> :
                                <span className="scoreboard-donor-roll-anonymous-amount"> {props.anonymousAmountVerbiage}</span>
                        }
                        {
                            showDesignation &&
                            <span><span className="scoreboard-donor-roll-designation-verbiage"> {props.designationVerbiage} </span><span className="scoreboard-donor-roll-designation-name">{DesignationName}</span></span>
                        }
                    </div>
                </DataGridCell>
            </ul>
        </div>)
}

DonorRollDataGridRow.displayName = 'DonorRollDataGridRow'
